export default "__VITE_ASSET__CrKHTmGY__"